import axios from 'axios';

export const getRabbitmqBaseUrl = () => {
  if (process.env.REACT_APP_RABBITMQ_URL) {
    return process.env.REACT_APP_RABBITMQ_URL.replace(/\/+$/, '');
  }
  const isLocalClient = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  
  const envApiUrl = process.env.REACT_APP_URL || process.env.REACT_APP_API_URL;
  
  // If client is running locally and REACT_APP_API_URL points to remote Cloud Run QA,
  // route RabbitMQ calls to the active local backend on :8080
  if (isLocalClient && (!envApiUrl || envApiUrl.includes('run.app'))) {
    return 'http://localhost:8080';
  }
  
  return (envApiUrl || 'http://localhost:8080').replace(/\/+$/, '');
};

const getBase = () => getRabbitmqBaseUrl();

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const rabbitmqApi = {
  getSnapshot: async () => {
    const res = await axios.get(`${getBase()}/api/rabbitmq/snapshot`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  getQueues: async (vhost) => {
    const url = vhost
      ? `${getBase()}/api/rabbitmq/queues?vhost=${encodeURIComponent(vhost)}`
      : `${getBase()}/api/rabbitmq/queues`;
    const res = await axios.get(url, { headers: getAuthHeaders() });
    return res.data;
  },

  getQueueDetail: async (name, params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query
      ? `${getBase()}/api/rabbitmq/queues/${encodeURIComponent(name)}?${query}`
      : `${getBase()}/api/rabbitmq/queues/${encodeURIComponent(name)}`;
    const res = await axios.get(url, { headers: getAuthHeaders() });
    return res.data;
  },

  getOverview: async () => {
    const res = await axios.get(`${getBase()}/api/rabbitmq/overview`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  getNodes: async () => {
    const res = await axios.get(`${getBase()}/api/rabbitmq/nodes`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  getBindings: async (vhost, queueName) => {
    const res = await axios.get(
      `${getBase()}/api/rabbitmq/bindings?vhost=${encodeURIComponent(vhost)}&name=${encodeURIComponent(queueName)}`,
      { headers: getAuthHeaders() }
    );
    return res.data;
  },

  peekMessages: async (data) => {
    const res = await axios.post(`${getBase()}/api/rabbitmq/peek`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  purgeQueue: async (vhost, queueName) => {
    const res = await axios.delete(
      `${getBase()}/api/rabbitmq/purge?vhost=${encodeURIComponent(vhost)}&name=${encodeURIComponent(queueName)}`,
      { headers: getAuthHeaders() }
    );
    return res.data;
  },

  getSettings: async () => {
    const res = await axios.get(`${getBase()}/api/rabbitmq/settings`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  updateSettings: async (settings) => {
    const res = await axios.post(`${getBase()}/api/rabbitmq/settings`, settings, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },

  testConnection: async (config) => {
    const res = await axios.post(`${getBase()}/api/rabbitmq/test-connection`, config, {
      headers: getAuthHeaders(),
    });
    return res.data;
  },
};

export default rabbitmqApi;
